import {zeroFill} from "./string";

export function dateToYYYYMMDD(date: Date, separator: string = "-"): string {
  return `${date.getFullYear()}${separator}${zeroFill(
    (date.getMonth() + 1).toString(),
    2
  )}${separator}${zeroFill(date.getDate().toString(), 2)}`;
}
